import React, { useState } from "react";
import { Card, Dropdown } from "react-bootstrap";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip
} from "recharts";
import { FiCalendar } from "react-icons/fi";

/* Year based data */
const yearData = {
  2026: [
    { name: "On Time", value: 1254, color: "#1f6677" },
    { name: "Late Attendance", value: 32, color: "#22c55e" },
    { name: "Work From Home", value: 658, color: "#f97316" },
    { name: "Absent", value: 14, color: "#ef4444" },
    { name: "Sick Leave", value: 68, color: "#fbbf24" }
  ],
  2025: [
    { name: "On Time", value: 1100, color: "#1f6677" },
    { name: "Late Attendance", value: 20, color: "#22c55e" },
    { name: "Work From Home", value: 500, color: "#f97316" },
    { name: "Absent", value: 30, color: "#ef4444" },
    { name: "Sick Leave", value: 40, color: "#fbbf24" }
  ],
  2024: [
    { name: "On Time", value: 900, color: "#1f6677" },
    { name: "Late Attendance", value: 45, color: "#22c55e" },
    { name: "Work From Home", value: 400, color: "#f97316" },
    { name: "Absent", value: 50, color: "#ef4444" },
    { name: "Sick Leave", value: 25, color: "#fbbf24" }
  ]
};

export default function LeaveStatsCard() {

  const [year, setYear] = useState("2026");
  const [activeIndex, setActiveIndex] = useState(null);

  const data = yearData[year];

  const onPieEnter = (_, index) => {
    setActiveIndex(index);
  };

  const onPieLeave = () => {
    setActiveIndex(null);
  };

  return (

<Card className="leave-card-design task-card h-100">

<Card.Header className="d-flex justify-content-between align-items-center card-header-custom">

<h5 className="mb-0">Leave Details</h5>

<Dropdown>

<Dropdown.Toggle
variant="light"
className="year-btn"
>
<FiCalendar className="me-1"/> {year}
</Dropdown.Toggle>

<Dropdown.Menu>
{Object.keys(yearData).map((y)=>(
<Dropdown.Item key={y} onClick={()=>setYear(y)}>
{y}
</Dropdown.Item>
))}
</Dropdown.Menu>

</Dropdown>

</Card.Header>

<Card.Body>

<div className="row align-items-center">

{/* LEFT SIDE DATA */}
<div className="col-md-6">

{data.map((item,index)=>(
<p key={index} className="data-row">

<span
className="dot"
style={{background:item.color}}
></span>

<span className="count">{item.value}</span>

<span className="label">{item.name}</span>

</p>
))}

</div>

{/* PIE CHART */}
<div className="col-md-6">

<ResponsiveContainer width="100%" height={220}>

<PieChart>

<Tooltip
contentStyle={{
background:"#0f4c5c",
border:"none",
borderRadius:"6px",
color:"#fff"
}}
/>

<Pie
data={data}
dataKey="value"
innerRadius={60}
outerRadius={90}
paddingAngle={2}
onMouseEnter={onPieEnter}
onMouseLeave={onPieLeave}
>

{data.map((entry,index)=>(
<Cell
key={index}
fill={entry.color}
style={{
opacity: activeIndex === null || activeIndex === index ? 1 : 0.4,
transform: activeIndex === index ? "scale(1.05)" : "scale(1)",
transformOrigin:"center",
transition:"all 0.3s"
}}
/>
))}

</Pie>

</PieChart>

</ResponsiveContainer>

</div>

</div>

{/* FOOTER */}
<p className="better-row">

<span className="check-box">✓</span>

Better than <b>85%</b> of Employees

</p>

</Card.Body>

<style>{`

.leave-card-design{
  border-radius:5px;
  border:2px solid #e5e7eb;
}

.card-header-custom{
  display:flex;
  justify-content:space-between;
  align-items:center;
  padding:18px;
  border-bottom:1px solid #eee;
  background:#ffffff;
}

.card-header-custom h5{
  margin:0;
  font-size:18px;
  font-weight:600;
}

/* BUTTON */
.year-btn{
  border:1px solid #e5e7eb;
  background:#fff;
  font-size:14px;
}

/* DATA ROW FIX (IMPORTANT) */
.data-row{
  display:flex;
  align-items:center;
  margin-bottom:14px;
  font-size:14px;
  color:#4b5563;
}

/* DOT */
.dot{
  width:7px;
  height:7px;
  border-radius:50%;
  margin-right:10px;
  flex-shrink:0;
}

/* NUMBER */
.count{
  font-weight:700;
  margin-right:6px;
  color:#111827;
  font-size:15px;
}

/* TEXT */
.label{
  margin-left:2px;
}

/* FOOTER */
.better-row{
  display:flex;
  align-items:center;
  gap:8px;
  margin-top:15px;
  font-size:14px;
}

.check-box{
  background:#f97316;
  color:#fff;
  width:22px;
  height:22px;
  display:flex;
  align-items:center;
  justify-content:center;
  border-radius:5px;
  font-size:12px;
}

/* RESPONSIVE */
@media (max-width:576px){
  .task-card{
    margin-top:20px;
  }
}

@media (max-width:992px){
  .task-card{
    margin-top:15px;
  }
}

@media (max-width:1024px){
  .task-card{
    margin-top:15px;
  }
}

`}</style>

</Card>

  );
}